import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./tailwind.css";
import "./components/ValueAssessment/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TranslationProvider } from "react-google-multi-lang";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './AuthContext';
import "./setupAxiosAuth";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <TranslationProvider
    apiKey={process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY}
    defaultLanguage="en"
  >
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </TranslationProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
